export enum DQ_PROVIDER {
  DATABRICKS = 'databricks'
}
export type DQDataBricksProvider = {
  providerType: DQ_PROVIDER.DATABRICKS;
  sqlServerHostName: string;
  databricksUrl: string;
  databricksToken: string;
  sqlHttpPath: string;
  runTableName: string;
  expectationTableName: string;
  databaseName: string;
};

export type DQProviderInfo = DQDataBricksProvider;

export type DQProvider<T = DQProviderInfo> = {
  providerInfo: T;
};
